import { MerchantSubmissionStatus as MerchantSubmissionStatusEnum } from "@redotech/cockroachdb-codegen/tables/merchant-submission-status";
import * as z from "zod";

export const merchantSubmissionStatusSchema = z.enum(
  MerchantSubmissionStatusEnum,
);

export type MerchantSubmissionStatus = z.infer<
  typeof merchantSubmissionStatusSchema
>;

export const merchantSubmissionRowSchema = z.object({
  id: z.string(),
  accountId: z.string(),
  teamId: z.string(),
  merchantName: z.string(),
  merchantDomain: z.string().nullable(),
  submissionKey: z.string(),
  schemaVersion: z.number(),
  payload: z.record(z.string(), z.unknown()),
  status: merchantSubmissionStatusSchema,
  submittedByName: z.string().nullable(),
  submittedByEmail: z.string().nullable(),
  submittedAt: z.string(),
  contactedAt: z.string().nullable(),
  closedAt: z.string().nullable(),
});

export type MerchantSubmissionRow = z.infer<typeof merchantSubmissionRowSchema>;

export const getMerchantSubmissions = {
  name: "getMerchantSubmissions" as const,
  input: z.object({
    limit: z.number().int().min(1).max(100).default(20),
    offset: z.number().int().min(0).default(0),
    status: merchantSubmissionStatusSchema.optional(),
    submissionKey: z.string().min(1).optional(),
    searchQuery: z.string().optional(),
  }),
  output: z.object({
    rows: z.array(merchantSubmissionRowSchema),
    total: z.number(),
  }),
};
